var map = {
	"./Archive": 2133,
	"./Archive.jsx": 2133,
	"./ArrowSwitch": 7405,
	"./ArrowSwitch.jsx": 7405,
	"./Bell": 6620,
	"./Bell.jsx": 6620,
	"./Blister": 221,
	"./Blister.jsx": 221,
	"./Bookmark": 9457,
	"./Bookmark.jsx": 9457,
	"./Box": 1426,
	"./Box.jsx": 1426,
	"./BoxImage": 7236,
	"./BoxImage.jsx": 7236,
	"./Building": 7137,
	"./Building.jsx": 7137,
	"./Calendar": 9950,
	"./Calendar.jsx": 9950,
	"./Carousel": 7979,
	"./Carousel.jsx": 7979,
	"./Check": 9797,
	"./Check.jsx": 9797,
	"./CheckCircle": 4894,
	"./CheckCircle.jsx": 4894,
	"./CheckGreen": 7606,
	"./CheckGreen.jsx": 7606,
	"./ChevronDown": 2887,
	"./ChevronDown.jsx": 2887,
	"./ChevronLeft": 7505,
	"./ChevronLeft.jsx": 7505,
	"./ChevronRight": 1080,
	"./ChevronRight.jsx": 1080,
	"./ChevronUp": 5775,
	"./ChevronUp.jsx": 5775,
	"./Chip": 6760,
	"./Chip.jsx": 6760,
	"./Circle": 8973,
	"./Circle.jsx": 8973,
	"./CircleArrow": 2233,
	"./CircleArrow.jsx": 2233,
	"./Clipboard": 2268,
	"./Clipboard.jsx": 2268,
	"./ClosedEye": 7968,
	"./ClosedEye.jsx": 7968,
	"./Coin": 1057,
	"./Coin.jsx": 1057,
	"./Coins": 2650,
	"./Coins.jsx": 2650,
	"./Copy": 5892,
	"./Copy.jsx": 5892,
	"./CreditCard": 9124,
	"./CreditCard.jsx": 9124,
	"./Cursor": 1398,
	"./Cursor.jsx": 1398,
	"./Display": 2675,
	"./Display.jsx": 2675,
	"./DollarCircle": 1858,
	"./DollarCircle.jsx": 1858,
	"./Dots": 8436,
	"./Dots.jsx": 8436,
	"./Download": 4431,
	"./Download.jsx": 4431,
	"./Edit": 4530,
	"./Edit.jsx": 4530,
	"./Envelope": 2529,
	"./Envelope.jsx": 2529,
	"./ExpandVertical": 1221,
	"./ExpandVertical.jsx": 1221,
	"./Eye": 8562,
	"./Eye.jsx": 8562,
	"./File": 8536,
	"./File.jsx": 8536,
	"./Filter": 7752,
	"./Filter.jsx": 7752,
	"./Graph": 9872,
	"./Graph.jsx": 9872,
	"./GridAlt": 1014,
	"./GridAlt.jsx": 1014,
	"./GridVertical": 4794,
	"./GridVertical.jsx": 4794,
	"./Group": 8171,
	"./Group.jsx": 8171,
	"./HamburguerMenu": 423,
	"./HamburguerMenu.jsx": 423,
	"./Hash": 7265,
	"./Hash.jsx": 7265,
	"./Heart": 2323,
	"./Heart.jsx": 2323,
	"./HelpCircle": 7696,
	"./HelpCircle.jsx": 7696,
	"./Home": 7768,
	"./Home.jsx": 7768,
	"./Image": 4667,
	"./Image.jsx": 4667,
	"./InfoCircle": 3731,
	"./InfoCircle.jsx": 3731,
	"./Instagram": 5782,
	"./Instagram.jsx": 5782,
	"./Like": 2938,
	"./Like.jsx": 2938,
	"./List": 2812,
	"./List.jsx": 2812,
	"./Lock": 177,
	"./Lock.jsx": 177,
	"./Logout": 2355,
	"./Logout.jsx": 2355,
	"./Magnifier": 341,
	"./Magnifier.jsx": 341,
	"./Mail": 1404,
	"./Mail.jsx": 1404,
	"./Menu": 9611,
	"./Menu.jsx": 9611,
	"./News": 2936,
	"./News.jsx": 2936,
	"./Package": 9032,
	"./Package.jsx": 9032,
	"./Palette": 5329,
	"./Palette.jsx": 5329,
	"./Percentage": 4262,
	"./Percentage.jsx": 4262,
	"./Phone": 8416,
	"./Phone.jsx": 8416,
	"./Photo": 2678,
	"./Photo.jsx": 2678,
	"./Pill": 8412,
	"./Pill.jsx": 8412,
	"./Pix": 4630,
	"./Pix.jsx": 4630,
	"./Plus": 3783,
	"./Plus.jsx": 3783,
	"./Pointer": 6643,
	"./Pointer.jsx": 6643,
	"./Refresh": 4997,
	"./Refresh.jsx": 4997,
	"./Repo": 7161,
	"./Repo.jsx": 7161,
	"./Search": 8695,
	"./Search.jsx": 8695,
	"./Send": 2018,
	"./Send.jsx": 2018,
	"./Settings": 8812,
	"./Settings.jsx": 8812,
	"./Show": 158,
	"./Show.jsx": 158,
	"./Smile": 3186,
	"./Smile.jsx": 3186,
	"./SortAltDown": 8999,
	"./SortAltDown.jsx": 8999,
	"./SortAltUp": 2970,
	"./SortAltUp.jsx": 2970,
	"./Star": 4720,
	"./Star.jsx": 4720,
	"./Stars": 5620,
	"./Stars.jsx": 5620,
	"./Support": 464,
	"./Support.jsx": 464,
	"./Target": 338,
	"./Target.jsx": 338,
	"./ToggleLeft": 9651,
	"./ToggleLeft.jsx": 9651,
	"./ToggleRight": 7569,
	"./ToggleRight.jsx": 7569,
	"./TransferAlt": 4537,
	"./TransferAlt.jsx": 4537,
	"./Trash": 7629,
	"./Trash.jsx": 7629,
	"./Twitter": 6498,
	"./Twitter.jsx": 6498,
	"./Update": 7034,
	"./Update.jsx": 7034,
	"./Upload": 9858,
	"./Upload.jsx": 9858,
	"./User": 7826,
	"./User.jsx": 7826,
	"./UserVoice": 2468,
	"./UserVoice.jsx": 2468,
	"./Wallet": 1899,
	"./Wallet.jsx": 1899,
	"./Whats": 615,
	"./Whats.jsx": 615,
	"./Whatsapp": 787,
	"./Whatsapp.jsx": 787,
	"./X": 3341,
	"./X.jsx": 3341,
	"./XCircle": 3541,
	"./XCircle.jsx": 3541,
	"./XLSX": 2242,
	"./XLSX.jsx": 2242
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5542;
module.exports = webpackAsyncContext;